/*
 * Copyright (c) 2020 Honeywell International, Inc. All rights reserved.
 *
 * This file contains trade secrets of Honeywell International, Inc.  No part
 *  may be reproduced or transmitted in any form by any means or for any
 *  purpose without the express written permission of Honeywell.
 *
 */
import React, { Component, Fragment, useState, useEffect } from "react";
import { Loader } from "@scuf/common";
import {
  IAxiosError,
  IGatewayRegProps,
} from "../../../stores/GatewayManager/IGatewayRegistrationInterfaces";
import "./GatewayRegistrationSetup.scss";
import { IGatewayDetails} from "../../gateway/registration/IGatewayDetails"
import { inject } from "mobx-react";
import {GatewayRegSuccessSummary} from "./GatewayRegistrationSuccessSummary";
import {GatewayRegFailedSummary} from "./GatewayRegistrationFailedSummary";


export const GatewayRegistrationSetup = (props: IGatewayRegProps) => { 
  
  const [isSuccess, setIsSuccess] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [errors, setErrors] = useState<IAxiosError>({} as IAxiosError);

  useEffect(() => {
    registerApplianceGateway();
  },[])

  const getAppLoader = () => {
    return (
      <div className="application-page-content ui-gateway-selection-container">
        <div className="ui-gateway-selection-title">Registering Gateway</div>
        <div className="loader-ui">
          <Loader text=" " loading={isLoading} />         
        </div>
      </div>
    );
  };

  const showSummaryComponent = () => {
    return (
      <div>
        {isSuccess ? (
          <GatewayRegSuccessSummary
            selectedGateway={props.selectedGateway}
          />
        ) : (
          <GatewayRegFailedSummary            
            axiosError = {errors} 
            gatewayDetails = {props.gatewayDetails}       
          />
        )}
      </div>
    );
  };

  const registerApplianceGateway = () => {
    let gatewayRegistration1 = props.gatewayRegistration;
    gatewayRegistration1!
      .registerGateway(props.selectedGateway)
      .then((response) => {
        setIsSuccess(true);
        setIsLoading(false);
      })
      .catch((error) => {
        setIsSuccess(false);
        setIsLoading(false);
        if(JSON.stringify(error.response.data.statusCode) != undefined){
          setErrors(error.response.data);
        }else if(JSON.stringify(error.response.status) === '401'){
          let errors : IAxiosError = {   
            message: 'You are unauthorized to perform this function.',
            httpStatus:'401',
            statusCode:401
          }
          setErrors(errors);
        }else if(JSON.stringify(error.response.status) === '500'){
          let errors : IAxiosError = {   
            message: error.response.data,
            httpStatus:JSON.stringify(error.response.status),
            statusCode:error.response.status
          }
          setErrors(errors);
        }else if(JSON.stringify(error.response.status) === '409'){
          let errors : IAxiosError = {   
            message: error.response.data.message,
            httpStatus:JSON.stringify(error.response.status),
            statusCode:error.response.status
          }
          setErrors(errors);
        }
        console.error("There was an error!", error.response.data);
      });
  };

  return <Fragment>{isLoading ? getAppLoader() : showSummaryComponent()}</Fragment>
    
  
};
export const GatewayRegSetup = inject("gatewayRegistration")(GatewayRegistrationSetup);